var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-2"},[(_vm.src && _vm.linkMode)?_c('a',{staticStyle:{"color":"dodgerblue"},attrs:{"target":"_blank","href":_vm.serverURL + '/' + _vm.src}},[_vm._v("View File")]):(_vm.src)?_c('img',{staticClass:"employee-image",attrs:{"src":_vm.serverURL + '/' + _vm.src,"alt":""}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }